import { Component, Input, OnInit } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatePipe } from '@angular/common';
import { GiftCardTransactionsViewModel, GroupGiftCardTransactionsViewModel } from "../../../models/recon-report-view-model";
import { ReportService } from '../../../services/report.service';
import { GenericReportViewModel, TransactionAmountModel, TransactionAmount, merchantDetails } from '../../../models/generic-report-view-model';

@Component({
  selector: 'giftcard-transaction-report-component',
  templateUrl: './giftcard-transaction-report.component.html'//,
})

export class GiftCardTransactionReportComponent implements OnInit {

  groupedTerminals: GroupGiftCardTransactionsViewModel[] = [];
  transactionReport: GiftCardTransactionsViewModel[] = [];
  transactionAmount: TransactionAmount[] = [];

  grandAmount: string;
  hasValue: boolean = false;
  raiseWarning!: boolean;
  merchantNameLocation: string;

  @Input() StartDate: string;
  @Input() EndDate: string;
  @Input() formatDate!: (date: string) => string;
  @Input() convertToDecimal: (amount?: number | null) => string;
  @Input() merchantDetails: merchantDetails =
  { merchantName: "", merchantNumber: "" };

  constructor(
    private loader: NgxUiLoaderService,
    private _reportService: ReportService,
    private datePipe: DatePipe) {
  }

  async ngOnInit() {
    this.loader.stop();
  }

  private resetState() {
    this.transactionReport = [];
    this.groupedTerminals = [];
    this.transactionAmount = [];
    this.hasValue = false;
    this.raiseWarning = false;
  }
  private handleEmptyState() {
    this.raiseWarning = true;
    this.loader.stop();
  }

  private transactionTypeMapping = {
    '00': 'Redemption',
    '21': 'Load',
    '20': 'Refund',
    '31': 'Balance Enquiry',
    '02': 'Debit Adjustment',
    '22': 'Credit Adjustment'
  };

  async GetReport(_reconReport: GenericReportViewModel) {

    this.resetState();
    this.transactionReport = await this._reportService.GetGiftCardData(_reconReport);

    debugger;
    if (!this.transactionReport?.length) {
      this.handleEmptyState();
      return;
    } else {

      const groupTerminalMapping = new Map<string, GroupGiftCardTransactionsViewModel>();

      this.transactionReport.forEach(recon => {

        const dateOfTransaction = this.formatDate(recon.datetimeReq);
        recon.datetimeReq = dateOfTransaction;

        if (!groupTerminalMapping.has(recon.terminalId)) {
          groupTerminalMapping.set(recon.terminalId, {
            terminalId: recon.terminalId,
            datetimeReq: this.datePipe.transform(recon.datetimeReq, 'yyyy-MM-dd hh:mm:ss'),
            pan: recon.pan,
            postTranId: recon.postTranId,
            totalsGroup: recon.totalsGroup,
            tranType: recon.tranType,
            amountAvailable: 0,
            items: []
          });
        }

        const group = groupTerminalMapping.get(recon.terminalId)!;
        group.items.push(recon);
        group.amountAvailable += recon.amountAvailable;
        group.amountAvailable = parseFloat(group.amountAvailable.toFixed(2));
      });

      this.groupedTerminals = Array.from(groupTerminalMapping.values());
      const total = this.groupedTerminals.reduce((sum, group) => sum + group.amountAvailable, 0);
      this.grandAmount = total.toFixed(2).toString();

      if (this.transactionReport.length > 0) {
        var transactionTypes: TransactionAmountModel[] = [];
        this.merchantNameLocation = this.transactionReport[0].merchantNameLocation + " - " + this.transactionReport[0].cardAcceptorIdCode;
        this.hasValue = true;
        transactionTypes = this.getTransactionTypes();

        this.merchantDetails = {
          merchantName: this.transactionReport[0].merchantNameLocation + " - GiftCard transaction report",
          merchantNumber: this.transactionReport[0].cardAcceptorIdCode,
        }

        for (const grp of transactionTypes) {
          this.transactionAmount.push(
            {
              tranType: "Grand Total " + grp.tranType,
              amount: parseFloat(""+grp.amount).toFixed(2), 
            })
        }

        //this.transactionAmount.push({
        //  tranType: "Grand Total",
        //  amount: parseFloat(this.grandAmount).toFixed(2)
        //});
      }
      this.loader.stop();
    }
  }

  getGiftCardTerminalTotalGroups(terminalId: string): any[] {
    const terminalGroups = this.transactionReport
      .filter(t => t.terminalId === terminalId)
      .reduce((groups, transaction) => {
        if (!groups[transaction.totalsGroup]) {
          groups[transaction.totalsGroup] = {
            totalsGroup: transaction.totalsGroup,
            amount: 0
          };
        }
        groups[transaction.totalsGroup].amount += transaction.amountAvailable;
        return groups;
      }, {} as any);

    return Object.values(terminalGroups).map((group: any) => ({
      ...group,
      amount: parseFloat(group.amount.toFixed(2))
    }));
  }

  getTerminalTransactionTypes(terminalId: string): any[] {

    const terminalTransactionTypes = this.transactionReport
      .filter(t => t.terminalId === terminalId)
      .reduce((types, transaction) => {
        const tranTypeCode = transaction.tranType;
        const tranTypeName = this.transactionTypeMapping[tranTypeCode] || `${tranTypeCode}`;

        if (!types[tranTypeCode]) {
          types[tranTypeCode] = {
            tranType: tranTypeCode,
            tranTypeName: tranTypeName,
            amount: 0
          };
        }
        types[tranTypeCode].amount += transaction.amountAvailable;
        return types;
      }, {} as any);

    return Object.values(terminalTransactionTypes).map((type: any) => ({
      ...type,
      amount: parseFloat(type.amount.toFixed(2))
    }));
  }

  public getTransactionTypes(): TransactionAmountModel[] {

    const result: Record<string, TransactionAmountModel> = {};

    for (const grp of this.groupedTerminals) {
      const terminalTransactions = this.transactionReport
        .filter(t => t.terminalId === grp.terminalId);

      for (const transaction of terminalTransactions) {
        const tranTypeCode = transaction.tranType;

        if (!result[tranTypeCode]) {
          result[tranTypeCode] = {
            tranType: tranTypeCode,
            amount: 0
          };
        }

        result[tranTypeCode].amount += transaction.amountAvailable;
      }
    }
    return Object.values(result);
  }
}
